var _defs, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgEmptyServicesHistory = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.09,
    y1: 0.477,
    x2: 1.09,
    y2: 0.477,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444,
    stopColor: "#f9f9fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eaeaf3"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noservice_history",
    transform: "translate(-5 -4.958)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6978",
    "data-name": "Ellipse 6978",
    cx: 75,
    cy: 75,
    r: 75,
    transform: "translate(5 4.958)",
    fill: "#eaeaf3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_34849",
    "data-name": "Group 34849"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63057",
    "data-name": "Path 63057",
    d: "M65.781,34.659h55.99a5.384,5.384,0,0,1,5.384,5.384v77.525a5.384,5.384,0,0,1-5.384,5.384H65.781a5.384,5.384,0,0,1-5.384-5.384V40.042A5.384,5.384,0,0,1,65.781,34.659Z",
    transform: "translate(187.552 157.611) rotate(180)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_34847",
    "data-name": "Group 34847"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63058",
    "data-name": "Path 63058",
    d: "M122.848,118.821H64.7a.178.178,0,0,1-.178-.178V38.965a.178.178,0,0,1,.178-.178h58.144a.178.178,0,0,1,.178.178v79.678A.178.178,0,0,1,122.848,118.821Zm-57.965-.356H122.67V39.143H64.883Z",
    fill: "#eaeaf3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_34848",
    "data-name": "Group 34848"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18109",
    "data-name": "Rectangle 18109",
    width: 48.453,
    height: 2.153,
    transform: "translate(68.875 73.421)",
    fill: "#eaeaf3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18110",
    "data-name": "Rectangle 18110",
    width: 48.453,
    height: 2.153,
    transform: "translate(68.875 79.881)",
    fill: "#eaeaf3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18111",
    "data-name": "Rectangle 18111",
    width: 48.453,
    height: 2.153,
    transform: "translate(68.875 86.342)",
    fill: "#eaeaf3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18112",
    "data-name": "Rectangle 18112",
    width: 16.151,
    height: 2.153,
    transform: "translate(101.177 44.349)",
    fill: "#eaeaf3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18113",
    "data-name": "Rectangle 18113",
    width: 16.151,
    height: 2.153,
    transform: "translate(101.177 48.656)",
    fill: "#eaeaf3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18114",
    "data-name": "Rectangle 18114",
    width: 16.151,
    height: 2.153,
    transform: "translate(101.177 52.963)",
    fill: "#eaeaf3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18115",
    "data-name": "Rectangle 18115",
    width: 48.453,
    height: 2.153,
    transform: "translate(68.875 60.5)",
    fill: "#eaeaf3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18116",
    "data-name": "Rectangle 18116",
    width: 48.453,
    height: 2.153,
    transform: "translate(68.875 66.96)",
    fill: "#eaeaf3"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_63059",
    "data-name": "Path 63059",
    d: "M56.628,37.95A26.587,26.587,0,1,1,30.04,64.537,26.618,26.618,0,0,1,56.628,37.95m0-3.041A29.628,29.628,0,1,0,86.256,64.537,29.628,29.628,0,0,0,56.628,34.909Z",
    fill: "#969bb7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63060",
    "data-name": "Path 63060",
    d: "M56.628,41.526A23.013,23.013,0,1,1,33.883,64.537,22.905,22.905,0,0,1,56.628,41.526m0-1.521A24.533,24.533,0,1,0,80.893,64.537,24.4,24.4,0,0,0,56.628,40.005Z",
    fill: "#eaeaf3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63061",
    "data-name": "Path 63061",
    d: "M56.4,122.951h0a3.89,3.89,0,0,1-3.89-3.89v-26.1h7.78v26.1A3.89,3.89,0,0,1,56.4,122.951Z",
    fill: "#969bb7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_39901",
    "data-name": "Group 39901",
    transform: "translate(-6.163 16.218)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63309",
    "data-name": "Path 63309",
    d: "M63.65,34.3A14.017,14.017,0,0,0,49.632,48.319H47.459L51,53.945l3.543-5.625H52.438a11.226,11.226,0,1,1,3.288,7.926L53.74,58.231A14.017,14.017,0,1,0,63.65,34.3Z",
    transform: "translate(0 0)",
    fill: "#969bb7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_35339",
    "data-name": "Group 35339",
    transform: "translate(62.201 39.927)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63310",
    "data-name": "Path 63310",
    d: "M62.5,47.183H55.552V37.39h2.8v6.99H62.5Z",
    transform: "translate(-55.552 -37.39)",
    fill: "#969bb7"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEmptyServicesHistory, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/empty-services-history.4071bf3e.svg";
export { ForwardRef as ReactComponent };